<template>
    <card-list-item>
        <template v-slot:icon><i class="fa-fw fa-user far"></i></template>
        <template v-slot:content>
            <div class="t-title">{{ participant.last_name }}, {{ participant.first_name }}</div>
            <div class="mt-2" v-if="maxLogMinutes > 0">
                <b-progress :type="progressType" size="is-small" :value="progressPercent" class="participant-progress"/>
                <div class="is-size-7 has-text-grey">{{ participant.formattedLogMinutes }} of {{ formattedMaxMinutes }} logged</div>
            </div>
            <div class="meta" v-else-if="participant.formattedLogMinutes !== '00:00'">
                <i class="fas fa-timer fa-fw mr-2"></i>{{ participant.formattedLogMinutes }} Logged
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import CardListItem from "@/TIER/components/CardListItem";

    export default {
        name: 'SessionParticipantTile',
        components: {CardListItem},
        props: {
            participant: {
                type: Object,
                required: true
            },
            maxLogMinutes: {
                type: Number,
                default: 0
            }
        },
        computed: {
            progressPercent() {
                if (this.maxLogMinutes <= 0) return 0;
                const percent = (this.participant.logMinutes / this.maxLogMinutes) * 100;
                return Math.min(percent, 100);
            },
            progressType() {
                if (this.progressPercent >= 100) return 'is-success';
                if (this.progressPercent >= 50) return 'is-primary';
                return 'is-warning';
            },
            formattedMaxMinutes() {
                const hours = Math.floor(this.maxLogMinutes / 60);
                const minutes = this.maxLogMinutes % 60;
                return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/variables';

    li {
        color: darken($t-primary, 18);
        padding: 0.5rem 0;

        .t-title {
            font-size: .9rem;
            font-weight: 700;
        }
    }
</style>

<style lang="scss">
    .participant-progress {
        margin-bottom: 0.2rem !important;

        .progress {
            height: 0.25rem !important;
        }
    }
</style>
